import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';

import { ChartType } from "chart.js";
import { ChartDataSets, ChartOptions } from "chart.js";
import { MultiDataSet, Label, Color, Colors, BaseChartDirective } from "ng2-charts";
import * as _moment from "moment";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import * as pluginAnnotations from "chartjs-plugin-annotation";
import Swal from 'sweetalert2';

import { Global } from 'src/app/globales/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { TitleCasePipe } from '@angular/common';
import { PaymentsService } from 'src/app/services/payments.service';
import { PaymentsLineChartService } from '../services/chart/payments-line-chart.service';
import { BankPaymentsAmountService } from '../services/chart/bank-payments-amount.service';
import { PaymentsStoreService } from '../services/payments-store.service';
import { takeUntil } from 'rxjs/operators';
import { Subscription } from 'rxjs';
const moment = (_moment as any).default ? (_moment as any).default : _moment;


@Component({
  selector: 'app-payments-amount',
  templateUrl: './payments-amount.component.html',
  styleUrls: ['./payments-amount.component.scss']
})
export class PaymentsAmountComponent implements OnInit, OnDestroy {
  @Input() data: any = [];
  @Input() labels: any = [];

  public lineChartData: ChartDataSets[] = [];

  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions & { annotation: any };

  public lineChartColors: Color[] = [];
  public lineChartLegend = true;
  public lineChartType: ChartType = "line";
  public lineChartPlugins = [pluginAnnotations];

  public amountChartState$ = this.store.amountChartState$;
  public subscription: Subscription;

  constructor(
    public titleCasePipe: TitleCasePipe,
    public spinner: NgxSpinnerService,
    public cdRef: ChangeDetectorRef,
    public global: Global,
    private lineChart: BankPaymentsAmountService,
    public store: PaymentsStoreService
  ) {
    this.initializeChart();
    this.subscription = this.amountChartState$.subscribe((state: any) => {
      this.lineChartData[0].data = state.chartData;
      this.lineChartLabels = state.chartLabels;
      this.cdRef.detectChanges();
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initializeChart() {
    this.lineChartColors = this.lineChart.lineChartColors;
    this.lineChartOptions = this.lineChart.lineChartOptions;
    this.lineChartData = this.lineChart.lineChartData;
    this.lineChartData[0].data = this.lineChart.lineChartData[0].data;
  }


}
